<template>
    <div>
        <div class="card-body">
            <h4 class="card-title">Withdraw from payment contract:</h4>
            <h6 class="card-subtitle">Funds are being held at this address</h6>
            <h6 class="address">{{selectedAddress}}</h6>

            <h4 class="card-title m-t-40">Deposit into:</h4>
            <h6 class="card-subtitle">Select your wallet address to transfer funds</h6>
            <select class="form-control address" id="addresses" style="width: 100%;height: 36px;" v-model="selectedAddress">
                <option v-bind:key="index" v-for="(a, index) in addresses"> {{a.address}}</option>
            </select>

            <button @click="withdraw()" class="btn btn-info m-t-40" type="button">Withdraw</button>
        </div>
        <div class="card-body">
            <p class="text-center aboutscroll">
                Withdraw funds into your wallet. You will be able to transfer funds to your bank account from your wallet.
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "WithdrawSpot",
        props: {
            trade: Object,
            events: Object
        },
        data() {
            return {
                selectedAddress: '',
                addresses: []
            }
        },
        beforeMount() {
            this.getAddresses();
        },
        methods: {
            format(state) {
                if(!state.id) {
                    return state.text;
                }
                let $state = $(
                '<span>HELLO' + state.text + '</span>'
                );
                return $state;
            },
            async getAddresses() {
                try {
                    let response = await this.$http.get("/wallets/addresses");
                    if(response.data !== null && response.data.length > 0) {
                        this.addresses = response.data;
                    }
                } catch(e) {
                    console.log(err);
                }
            },
            async withdraw() {
                try {
                    $(".preloader").fadeIn();
                    await this.$http.post('/trades/' + this.trade.trade_id + '/withdraw', {to: this.selectedAddress, comments: ''});
                    this.events.$emit('trade:reload');
                    $(".preloader").fadeOut();
                    this.$toastr('success', 'Funds received', 'Escrow withdrawn');
                } catch(e) {
                    $(".preloader").fadeOut();
                    console.log(e);
                    this.$toastr('error', 'Escrow withdraw failed', 'Failed');
                }
            }
        }
    }
</script>

<style scoped>
    h6.address {
        font-family: Source Code Pro, monospace;
        color: #4f5382;
        font-size: 12px;
    }

    select.address {
        font-family: Source Code Pro, monospace;
        font-weight: 700;
        color: #4f5382;
        font-size: 12px;
    }

    .select2-selection__rendered {
        display: block;
        padding-left: 8px;
        padding-right: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-family: Source Code Pro, monospace;
        font-weight: 700;
        color: #4f5382;
        font-size: 12px;
    }
</style>
